// Copyright © 2021 Move Closer
import { hasSizeProp } from '../../_composables';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractIconProps = {
    ...hasSizeProp,
    /**
     * The name (identifier) of the icon we want to render.
     */
    name: {
        type: String,
        required: true
    }
};
